import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import DestinationCatalog from "../../../views/SumaTravel/CatalogoDestinos/DestinationCatalog";
import AdministradorPromociones from "../../../views/SumaTravel/AdministradorPromociones/AdministradorPromociones";
import CotizacionTabla from "../../../views/SumaTravel/Cotizaciones/CotizacionTabla";
import CotInegi from "../../../views/SumaTravel/Cotizaciones/Components/CotInegi";
import PaymentView from "../../../views/SumaTravel/Payments/PaymentView";
import EncuestasDashboard from "../../../views/SumaTravel/Reportes/EncuestasDashboard";

// Lazy loading para mejorar rendimiento
const CotizacionComponent = lazy(() => import("../../../views/SumaTravel/Cotizaciones/Components/CotizacionComponent"));
const SpecialServices = lazy(() => import("../../../views/SumaTravel/ServiciosEspeciales/SpecialServices"));
const MainForm = lazy(() =>
    import("../../../views/SumaTravel/ServiciosEspeciales/ServiciosEspecialesConfig/PrincipalComponent")
);

const SumaTravel = () => {
    return (
        <Suspense fallback={<>Cargando...</>}>
            <Routes>
                <Route path="/suma-travel/cotizaciones" element={<CotizacionTabla />} />
                <Route path="/suma-travel/cotizaciones/:id" element={<CotizacionComponent />} />
                <Route path="/suma-travel/cotizaciones/nueva" element={<CotizacionComponent />} />
                <Route path="/suma-travel/catalogo-destinos" element={<DestinationCatalog />} />
                <Route path="/suma-travel/servicios-especiales" element={<SpecialServices />} />
                <Route path="/suma-travel/servicio/:id" element={<MainForm />} />
                <Route path="/suma-travel/pagos-especiales/:folioId" element={<PaymentView />} />
                <Route path="/suma-travel/administrador-promociones" element={<AdministradorPromociones />} />
                <Route path="/suma-travel/encuestas" element={<EncuestasDashboard />} />
            </Routes>
        </Suspense>
    );
};

export default SumaTravel;
